import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

const ZoomIn = keyframes`
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
      opacity: 1;
    }
`;

export const Step = styled.div`
  width: 620px;
  max-width: 100%;
  margin: 0 auto;
  animation: ${ZoomIn} 0.25s ease;
`;

export const WideStep = styled(Step)`
  width: 900px;
  animation: none;
`;

export const StepBox = styled.div`
  background: ${tokens.color.white};
  padding: ${tokens.spacer.x4};
  box-shadow: ${tokens.elevation(2)};
  border-radius: ${tokens.radius.m};
`;
